import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { UIRouterModule } from '@uirouter/angular';
import { MARKED_OPTIONS, MarkdownModule } from 'ngx-markdown';

import { ProjectModule } from '../project/project.module'

import { CoreWidgetsModule } from '../../../widgets/core.widgets.module';
import { NotebookModule } from '../../../widgets/notebook/notebook.module';
import { CoreServicesModule } from '../../core.services.module';
import { CoreFiltersModule } from '../../core.filters.module';
import { gfMarkedOptionsFactory } from '../../services/core.markdown-editor.service';

import { NewUserComponent } from './new-user/new-user.component';
import { ChangeEmailRequestComponent } from './changeemail/request/changeemail.request.component';
import { ChangeEmailRequestModalComponent } from './changeemail/request/changeemail.request.modal.component';
import { ChangeEmailConfirmComponent } from './changeemail/confirm/changeemail.confirm.component';
import { ChangeEmailHelper } from './changeemail/request/changeemail.helper';
import { UserProfileEditComponent } from './edit-profile/user.edit-profile.component';
import { UserHeaderService } from './header/user.header.service';
import { UserHeaderComponent } from './header/user.header.component';
import { UserHeadingDropdownComponent } from './user-heading-dropdown/user.heading-dropdown.component';
import { UserDeleteModalComponent } from './delete-user/delete.user.modal.component';
import { ChangePasswordComponent } from './changepassword/changepassword.component';
import { LoginComponent } from './login/login.component';
import { LoginTabsComponent } from './login-tabs/login-tabs.component';
import { UserHomeViewComponent } from './home/user.home.component';
import { UserStatusBlocksComponent } from './status-blocks/user.status-blocks.component';
import { LostPasswordViewComponent } from './lostpassword/lostpassword.component';
import { UserMyViewComponent } from './my/user.my.component';
import { UserNotificationsViewComponent } from './notifications/user.notifications.component';
import { SshKeysViewComponent } from './ssh-keys/user.ssh-keys.component';
import { ResetPasswordViewComponent } from './resetpassword/resetpassword.component';
import { ConfirmViewComponent } from './userRegistration/confirm/confirm.component';
import { UserRegistrationRequestComponent } from './userRegistration/request/user.registration.request.component';
import { RegisterViewComponent } from './userRegistration/register/register.component';
import { MyReportsFilterService } from './myreports/services/myreports.service.filters';
import { MyReportsRest } from './myreports/services/myreports.service';
import { MyReportsFilterComponent } from './myreports/filter/myreports.filter.component';
import { MyReportsHeaderComponent } from './myreports/header/myreports.header.component';
import { MyReportsListComponent } from './myreports/list/myreports.list.component';
import { MyReportsReportComponent } from './myreports/report/myreports.report.component';
import { UserNotebookComponent } from './notebook/user.notebook.component';
import { UserNotebookPageComponent } from './notebook/user.notebook-page.component';
import { FileTypeService } from '../../../plugins/tracker/services/file-type.service';

import { USER_STATES } from './core.user.routes';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        CoreWidgetsModule,
        NotebookModule,
        CoreServicesModule,
        CoreFiltersModule,
        ReactiveFormsModule,
        ProjectModule,
        // forRoot() provides MarkdownService/MarkedOptions, which <markdown> requires.
        // CoreUserModule is eagerly loaded, so a plain MarkdownModule import would leave
        // MarkdownService unprovided and every <markdown> in the notebook would throw.
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MARKED_OPTIONS,
                useFactory: gfMarkedOptionsFactory
            }
        }),
        UIRouterModule.forChild({
            states: USER_STATES
        })
    ],
    providers: [
        ChangeEmailHelper,
        UserHeaderService,
        MyReportsFilterService,
        MyReportsRest,
        FileTypeService
    ],
    declarations: [
        NewUserComponent,
        ChangeEmailRequestComponent,
        ChangeEmailRequestModalComponent,
        ChangeEmailConfirmComponent,
        UserProfileEditComponent,
        UserHeaderComponent,
        UserHeadingDropdownComponent,
        UserDeleteModalComponent,
        ChangePasswordComponent,
        LoginComponent,
        LoginTabsComponent,
        UserHomeViewComponent,
        UserStatusBlocksComponent,
        LostPasswordViewComponent,
        UserMyViewComponent,
        UserNotificationsViewComponent,
        SshKeysViewComponent,
        ResetPasswordViewComponent,
        ConfirmViewComponent,
        UserRegistrationRequestComponent,
        RegisterViewComponent,
        MyReportsFilterComponent,
        MyReportsHeaderComponent,
        MyReportsListComponent,
        MyReportsReportComponent,
        UserNotebookComponent,
        UserNotebookPageComponent
    ],
    exports: [
        LoginComponent,
        RegisterViewComponent,
        ConfirmViewComponent,
        UserRegistrationRequestComponent
    ]
})
export class CoreUserModule {
    constructor() { }
}
